import services from "../services";

export const relatedBillerActions = {
  getAllChildBiller,
  getParentBiller,
  updateMonthlyInvoiceForChildBiller,
  removeBillerRelationShip,
  getRelatedBillerSearch,
  addBillerRelationship,
};

function getAllChildBiller(reqData, props) {
  return services.relatedBillerService.getAllChildBiller(reqData, props);
}
function addBillerRelationship(reqData, props) {
  return services.relatedBillerService.addBillerRelationship(reqData, props);
}
function getParentBiller(reqData, props) {
  return services.relatedBillerService.getParentBiller(reqData, props);
}

function updateMonthlyInvoiceForChildBiller(reqData, props) {
  return services.relatedBillerService.updateMonthlyInvoiceForChildBiller(
    reqData,
    props
  );
}

function removeBillerRelationShip(reqData, props) {
  return services.relatedBillerService.removeBillerRelationShip(
    reqData,
    props
  );
}

function getRelatedBillerSearch(reqData, props) {
  return services.relatedBillerService.getRelatedBillerSearch(
    reqData,
    props
  );
}
